import res from './res'

res.add('ru', {
    selectionOptions: {
        all: 'Выбрать все',
        none: 'Очистить',
        invert: 'Инвертировать'
    }
})
